export const maxColSpan = 24;
